import { format, parseISO } from 'date-fns'
import { id } from 'date-fns/locale'

export const formatDate = (date, formatStr = 'dd MMM yyyy') => {
  if (!date) return '-'
  try {
    const parsedDate = typeof date === 'string' ? parseISO(date) : date
    return format(parsedDate, formatStr, { locale: id })
  } catch {
    return '-'
  }
}

export const formatDateTime = (date, formatStr = 'dd MMM yyyy - HH:mm:ss') => {
  if (!date) return '-'
  try {
    const parsedDate = typeof date === 'string' ? parseISO(date) : date
    return format(parsedDate, formatStr, { locale: id }) + ' WIB'
  } catch {
    return '-'
  }
}

export const formatTime = (date, formatStr = 'HH:mm:ss') => {
  if (!date) return '-'
  try {
    const parsedDate = typeof date === 'string' ? parseISO(date) : date
    return format(parsedDate, formatStr, { locale: id })
  } catch {
    return '-'
  }
}

export const formatCurrency = (amount) => {
  if (amount == null) return '-'
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR'
  }).format(amount)
}

export const getCurrentPosition = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'))
      return
    }
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy
        })
      },
      (error) => {
        reject(error)
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    )
  })
}

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email)
}

export const storage = {
  get: (key) => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : null
    } catch {
      return null
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      console.error('Error saving to localStorage')
    }
  },
  remove: (key) => {
    try {
      localStorage.removeItem(key)
    } catch {
      console.error('Error removing from localStorage')
    }
  },
  clear: () => {
    try {
      localStorage.clear()
    } catch {
      console.error('Error clearing localStorage')
    }
  }
}